.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.description {
  margin: 0.5rem 0 1rem;
  max-width: 48rem;
}

.note {
  margin: 0.25rem 0;
  max-width: 48rem;
  font-size: 0.9rem;
  opacity: 0.8;
}

/* Danger zone — visually set apart so destructive actions are deliberate, not accidental. */
.dangerZone {
  border: 1px solid var(--color-error, #b20303);
}

.dangerZone h2 {
  color: var(--color-error, #b20303);
}

.deleteButton {
  margin-top: 1rem;
  background-color: var(--color-error, #b20303);
  border-color: var(--color-error, #b20303);
  color: #fff;
}

.deleteButton:disabled {
  opacity: 0.5;
}
